import axiosInstance from '../axiosInterceptor/axiosInstance'

const getFederationStructure = async (orgId) => {
  const url = `v1/orgs/${orgId}/competitions/structure`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getFederationStructure
